import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Navbar from './Navbar';
import { HomeTemplatesProvider } from '../context/HomeTemplatesContext';

const MainLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
        width: '100%',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <Navbar />
      <Box
        component="main"
        sx={{
          p: 2,
          width: '100%',
          maxWidth: 1200,
          mx: 'auto',
          boxSizing: 'border-box',
          overflowX: 'hidden',
        }}
      >
        <HomeTemplatesProvider>
          <Outlet />
        </HomeTemplatesProvider>
      </Box>
    </Box>
  );
};

export default MainLayout;
